import { render } from "./EditPreIngestion.vue?vue&type=template&id=058579f6&scoped=true"
import script from "./EditPreIngestion.vue?vue&type=script&lang=js"
export * from "./EditPreIngestion.vue?vue&type=script&lang=js"

import "./EditPreIngestion.vue?vue&type=style&index=0&id=058579f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-058579f6"]])

export default __exports__